import React from 'react';
import Panel from '../Panel/Panel';
import NumberSpinner from '../NumberSpinner/NumberSpinner';
import numeral from "numeral";
import Carousel from '../Carousel/Carousel';

export default class BookingProduct extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fullscreenImages: false,
      quantity: 1,
    };

    this.images = React.createRef();
    this.fullscreen_images = React.createRef();
    this.onAddToCart = this.onAddToCart.bind(this);
    this.onChangeQuantity = this.onChangeQuantity.bind(this);
    this.onToggleFullscreenImages = this.onToggleFullscreenImages.bind(this);
  }

  componentDidMount() {
    $(window).on('bookingProductsReservationSegmentChange', () => {
      this.setState({quantity: 1});
    });
  }

  componentWillUnmount() {
    $(window).off('bookingProductsReservationSegmentChange');
  }

  /**
  * Render functions
  */

  render(product) {
    var product = this.props.product;

    return (
      <div key={product.id} className="product">
        <Panel name={product.id}
               expanded={this.props.expanded}
               onExpandCollapse={this.props.onExpandCollapse}
               header={this.renderHeader(product)}
               body={this.renderBody(product)}
        />
        {this.state.fullscreenImages ? this.renderFullscreenImages() : null}
      </div>
    );
  }

  renderHeader(product) {
    if (this.props.expanded) {
      return null;
    }

    if (product.image_group && product.image_group.images && product.image_group.images.length > 0) {
      var image = <img src={product.image_group.images[0].max_square_url} className="can-expand-collase" />;
    } else {
      var image = <img src={this.props.default_hotel_room_icon_path} width="100%" className="can-expand-collase" />;
    }

    return (
      <div>
        <div className="left-side can-expand-collase">
          {image}
          <div className="amount-tag can-expand-collase">{this.props.currency.symbol}{numeral(product.amount * this.props.currency.exchange_rate  / 100).format(this.props.number_format)}</div>
        </div>
        <div className="right-side can-expand-collase">
          <h2 className="name can-expand-collase">{product.name}</h2>
          <p className="description can-expand-collase" dangerouslySetInnerHTML={{__html: product.description}}></p>
        </div>
      </div>
    );
  }

  renderBody(product) {
    return (
      <div>
        <div className="row">
          <div className="col-sm-6 images-wrapper">
            {this.renderFirstImage(product)}
          </div>
          <div className="col-sm-6">
            <div className="name">{product.name}</div>
            <div className="description">{product.description}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">

            <div className="amount">
              {this.props.currency.symbol}{numeral(product.amount * this.props.currency.exchange_rate / 100).format(this.props.number_format)}
              <span className="with-taxes-and-fees" style={{fontWeight: 'normal', color: '#777', fontSize: '12px', lineHeight: '12px', margin: '0 5px 0 0'}}> {I18n.t('plus_taxes_and_fees')}</span>

            </div>
            {this.renderButtons(product)}
          </div>
        </div>
      </div>
    );
  }

  renderButtons(product) {
    if (this.props.cart && this.props.cart[this.props.reservation_segment_id] && this.props.cart[this.props.reservation_segment_id][product.id]) {
      var quantity = this.props.cart[this.props.reservation_segment_id][product.id]
      return (
        <div className="add-to-cart">
          <div className="added">
            <span className="ss-check"></span> {quantity > 1 ? quantity : null} {I18n.t('added')}
          </div>
          <button type="button" className="btn btn-secondary btn-lg cart-button" onClick={this.props.onRemoveFromCart.bind(null, product.id)}>{I18n.t('remove')}</button>
        </div>
      );
    } else {
      return (
        <div className="add-to-cart">
          {
            product.quantity_allowed
            ?
            <div className="quantity"><NumberSpinner id="quantity" name="quantity" value={this.state.quantity} onChange={this.onChangeQuantity} /></div>
            :
            null
          }
          <button type="button" className="btn btn-primary btn-lg cart-button" onClick={this.onAddToCart}>{I18n.t('add_to_cart')}</button>
        </div>
      );
    }
  }

  renderFirstImage(product) {
    if (product.image_group && product.image_group.images && product.image_group.images.length > 0) {
      return (
        <div className="left-side">
          <img src={product.image_group.images[0].max_square_url} onClick={this.onToggleFullscreenImages} style={{cursor: 'pointer'}} />
        </div>
      );
    }
  }

  renderFullscreenImages() {
    var images = this.props.product.image_group.images.map(function (image) {
      return <img src={image.max_square_url} key={image.id} />
    });
    return (
      <div className="fullscreen-images">
        <div className="overlay"></div>
        <a href="#" className="close-button" onClick={this.onToggleFullscreenImages}>{I18n.t('hide_photos')}</a>
        <div>
          <Carousel displayArray={images} />
        </div>
      </div>
    );
  }

  /**
  * Change handlers
  */

  onAddToCart() {
    this.props.onAddToCart(this.props.product.id, this.state.quantity);
  }

  onChangeQuantity(event) {
    this.setState({quantity: parseInt(event.target.value)});
  }

  onToggleFullscreenImages(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({fullscreenImages: this.state.fullscreenImages ? false : true});
  }

};
